// extracted by mini-css-extract-plugin
module.exports = {"ingLinkStyles":"INGHeaderLogo_ingLinkStyles__3azTg","ingLogosStyle":"INGHeaderLogo_ingLogosStyle__23ONm"};